import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import sensorsReport from './utils/sensors.report'
import VueScrollTo from 'vue-scrollto'

import i18n from './locales'

Vue.config.productionTip = false

Vue.use(VueScrollTo)

sensorsReport.init(false)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
